import React, { useEffect } from "react";
import Header from "./global/Header";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./home/Home";
import { getAuthDetails } from "./auth/authService";
import { useDispatch } from "react-redux";

// form inputs

import Footer from "./global/Footer";
import Contact from "./contact/Contact";

import HowItWorks from "./howitworks/HowItWorks";
import About from "./about/About";
import FoodMenu from "./menu/FoodMenu";
import Subscription from "./subscription/Subscription";
import Thankyou from "./global/Thankyou";
import TestimonialSlider from "./global/TestimonialSlider";
import Checkout from "./subscription/Checkout";
import PaymentStatus from "./payments/PaymentStatus";
import Login from "./signin/Login";
import { useSelector } from "react-redux";
import TermsAndConditions from "./global/TermsAndConditions";
import PrivacyPolicy from "./global/PrivacyPolicy";
import RefundPolicy from "./global/RefundPolicy";

import { Toaster } from "react-hot-toast";
import RotatingMessage from "./global/RotatingMessage";

const App = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.auth.user);

  useEffect(() => {
    dispatch(getAuthDetails());
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Toaster />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/form" element={<MultiStepForm />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/menu" element={<FoodMenu />} />
        <Route
          path="/subscription"
          element={data ? <Subscription /> : <Login />}
        />
        <Route path="/subscription/checkout" element={<Checkout />} />
        <Route
          path="/redirect-url/:merchantTransactionId"
          element={<PaymentStatus />}
        />
        <Route path="/howitworks" element={<HowItWorks />} />
        <Route path="/howitworks" element={<HowItWorks />} />
        <Route path="/exapmle" element={<TestimonialSlider />} />
        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/refundpolicy" element={<RefundPolicy />} />
        <Route path="/login" element={<Login />} />
      </Routes>
      <RotatingMessage />
      <Footer />
    </BrowserRouter>
  );
};

export default App;
